import howToInvestMoneyFrenchImg from 'assets/images/howToInvestMoneyFrench.png';

import { FLIP_BOOK, GIFT_BOOK, FLIP_BOOKS } from '../const';

import { getFlipBookPurchases } from './utils';

const howToInvestMoneyFrench = {
  book: {
    id: 'geldanlegen-aktien-fr',
    format: FLIP_BOOKS,
    title: 'How to invest money (french version)',
    subtitle: '',
    videos: 'Erwin W. Heri, Nicolas Plain',
    layoutAndProduction: 'Hanspeter Frey',
    scope: { pages: 39, videos: 30 },
    price: [32, 39],
    introductions: ['The first digital book in a series on the basics of investing deals with shares'],
    image: howToInvestMoneyFrenchImg,
    overviewImg: howToInvestMoneyFrenchImg,
  },
  bookIds: [49, 50],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [FLIP_BOOK, GIFT_BOOK],
  purchases: getFlipBookPurchases([32, 39], [50, 49]),
};

export default howToInvestMoneyFrench;
